import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "analista" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      navigate("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha ao criar conta");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F9FAFB]">
      <Card className="w-full max-w-md p-8 border rounded-sm">
        <h2 className="font-heading font-bold text-2xl mb-6">Criar conta</h2>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wider">Nome</Label>
            <Input data-testid="register-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="rounded-sm mt-1" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">E-mail</Label>
            <Input data-testid="register-email-input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="rounded-sm mt-1" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Senha</Label>
            <Input data-testid="register-password-input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6} className="rounded-sm mt-1" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Perfil</Label>
            <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger data-testid="register-role-select" className="rounded-sm mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="administrador">Administrador</SelectItem>
                <SelectItem value="analista">Analista</SelectItem>
                <SelectItem value="visualizacao">Visualização</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button data-testid="register-submit-btn" type="submit" disabled={loading} className="w-full rounded-sm bg-[#0A3B2C] hover:bg-[#083527] text-white">
            {loading ? "Criando..." : "Criar conta"}
          </Button>
        </form>
        <div className="mt-4 text-xs text-muted-foreground">
          Já tem conta? <Link to="/login" className="text-[#0A3B2C] font-semibold underline">Entrar</Link>
        </div>
      </Card>
    </div>
  );
}
